var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"pa-6 ",attrs:{"fluid":""}},[_c('DatatableV2',{attrs:{"url":_vm.apiUrl},on:{"openDrawerObject":_vm.openDrawerObject}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }